'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSwapCalls = function MdSwapCalls(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 6.6l6.6 6.8h-5v11.6c0 3.7-2.9 6.6-6.6 6.6s-6.6-2.9-6.6-6.6v-11.6c0-1.8-1.6-3.4-3.4-3.4s-3.4 1.6-3.4 3.4v11.6h5l-6.6 6.6-6.6-6.6h5v-11.6c0-3.7 2.9-6.8 6.6-6.8s6.6 3.1 6.6 6.8v11.6c0 1.8 1.6 3.4 3.4 3.4s3.4-1.6 3.4-3.4v-11.6h-5z' })
        )
    );
};

exports.default = MdSwapCalls;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/swap-calls.js
// module id = 2837
// module chunks = 0